export default __webpack_public_path__ + "static/media/6_Still.25899571.jpg";